const actionTypes = require('constants/actionTypes');
// @ utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { DATE_FORMAT_API,  } = require('constants/index');
const moment = require('moment');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
const { CIC_CHANNEL,
        API_CENTER,
        API_ENTERPRISE_NUMBER} = require('constants/index');

const fetchCancelPostPayDataRequest = () => ({
    type: actionTypes.FETCH_CANCEL_POST_PAY_DATA_REQUEST
});

const fetchCancelPostPayDataSuccess = (data) => ({
    type: actionTypes.FETCH_CANCEL_POST_PAY_DATA_SUCCESS,
    payload: {
        data
    }
});

const fetchCancelPostPayDataFailure = (error) => ({
    type: actionTypes.FETCH_CANCEL_POST_PAY_DATA_FAILURE,
    payload: {
        error
    }
});

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.CANCEL_POST_PAYMENT_SET_VISIBLE_STEP,
        payload: {
            step
        }
    });
};

const validateStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.CANCEL_POST_PAYMENT_STEP_VALIDATE,
        payload: {
            step
        }
    });
};

const modifyRequest = () => ({
    type: actionTypes.CANCEL_POST_PAYMENT_REQUEST
});


const modifySuccess = (data) => ({
    type: actionTypes.CANCEL_POST_PAYMENT_SUCCESS,
    payload: {
        data
    }
});

const modifyFailure = (error) => ({
    type: actionTypes.CANCEL_POST_PAYMENT_FAILURE,
    payload: {
        error
    }
});


function setWillCancel() {
    return {
        type: actionTypes.CANCEL_POST_PAYMENT_CANCEL,
    };
}

const reset = () => ({
    type: actionTypes.CANCEL_POST_PAYMENT_RESET
});

const requestCancelPostPayData = (cardId) => (dispatch, getState) => {
    const immCard = getState().cards.get('byId').get(cardId);
    const pan = immCard.get('number');
    const numeroContrato= immCard.getIn(['contract', 'number']);
    const producto= immCard.getIn(['contract', 'product']);
        const requestData = {
            query: {
                producto: producto,
                panTarjeta: pan,
                numeroContrato: numeroContrato
            }
        };

        dispatch(fetchCancelPostPayDataRequest());
        return APIGet({
            dispatch,
            endpoint: 'requestCancelPostPayData',
            params: requestData
        })
        .then((response) => dispatch(fetchCancelPostPayDataSuccess(response)))
        .catch((response) => {
            if (!!response.error) {
                dispatch(fetchCancelPostPayDataFailure(response.error));
            } else {
                throw response;
            }
        });
    }


const cancelPostPaymentSuccess = (cardId, paymentDetail) => (dispatch, getState) => {
    var immCard = getState().cards.getIn(['byId', cardId]);
    const pan = immCard.get('number');
    const numerodecontrato =  immCard.getIn(['contract', 'number']);
    const producto = immCard.getIn(['contract', 'product']);
    const ctosaldo = paymentDetail.get('ctosaldo');
    const fecanota = paymentDetail.get('fecanota');
    const fecopera = paymentDetail.get('fecopera');
    const divisa = paymentDetail.getIn(['importe', 'divisa']);
    const importe = paymentDetail.getIn(['importe', 'importe']);
    const diamovto = paymentDetail.get('liamovto');
    const currentDate = moment().format(DATE_FORMAT_API);
    let endpoint;
    if(fecanota == currentDate){
        endpoint = 'cancelPostPaymentToday'
    }else{
        endpoint = 'cancelPostPaymentHistory'
    }
    const callback = (dispatch, getState, dataToken) => {

    const requestData = {
            query: {
                "canal": CIC_CHANNEL,
                "contratoML": {
                    "centro": {
                        "centro": API_CENTER,
                        "empresa": API_ENTERPRISE_NUMBER
                    },
                    "numerodecontrato": numerodecontrato,
                    "producto": producto
                },
                "ctosaldo":ctosaldo,
                dataToken,
                "diamovto": diamovto,
                "fecanota": fecanota,
                "fecopera": fecopera,
                "importe": {
                    "divisa": divisa,
                    "importe": importe
                },
                "pan": pan
            }
        };
        dispatch(modifyRequest());
        return APIPost({
            dispatch,
            endpoint: endpoint,
            params: requestData
        })
        .then((response) => dispatch(modifySuccess(response)))
        .catch((response) => {
            if (!!response.error) {
                dispatch(modifyFailure(response.error));
            } else {
                throw response;
            }
        });
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
}

module.exports = {
    setVisibleStep,
    setWillCancel,
    validateStep,
    reset,
    cancelPostPaymentSuccess,
    requestCancelPostPayData
}
